// extracted by mini-css-extract-plugin
export var oskarContainer = "oskar-payment-module--oskarContainer--6aedc";